module.exports = __webpack_public_path__ + "img/IND-A-1-I.3f8bbcaf.png";